import configService from '@lib/services/configService';

export const HOST_VARIANT_KEY = `${configService.getAppPrefix()}-hostVariant`;

export enum EHostVariant {
  Embedded = 'embedded',
}

export default function getHostVariant() {
  return sessionStorage.getItem(HOST_VARIANT_KEY) as EHostVariant | null;
}
